import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { DATA_TOKEN, ICDKPortalComponent } from '../../Theme/services/zen-cdk.service';
import { LanguageService } from '@ex/module/core/services/language.service';
import { GeneralService } from '@ex/module/core/services/general.service';
import { Observable } from 'rxjs';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { EssentialObject } from '@ex/module/core/services/essential-object.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ExtractNameLanguagePipe } from '../../pipes/extract-name-language.pipe';
import { LanguagePipe } from '../../pipes/language.pipe';
import { AppInjector } from '@ex/module/app.module';
import { LoaderService } from '@ex/module/core/services/loader.service';


@Component({
  selector: 'app-pdf-chart-exporter',
  templateUrl: './pdf-chart-exporter.component.html',
  styleUrls: ['./pdf-chart-exporter.component.scss'],
  providers: [ExtractNameLanguagePipe]

})
export class PdfChartExporterComponent extends BaseComponent implements ICDKPortalComponent, OnInit {
  date: Date = new Date();
  title: string
  extractedTitle: any;
  fileName: any
  extractedText: any
  reportName: any

  constructor(@Inject(DATA_TOKEN) private data: any,
    public loaderService: LoaderService,
    public languageService: LanguageService,) {
    super();

  }
  ngOnInit() {

    // this code does not follow any logic or reasonable flow, it needs to be modified later on. extremely unsettling. I hate it.

    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(this.data.chartHTML.outerHTML, 'text/html');
    const element = parsedHtml.querySelector('.text-zen.text-2xl.font-medium.title.exportmode') as HTMLElement;
    if (element) {
      const extractedText = element.innerText || element.textContent;
      console.log('Extracted Text:', extractedText);
      this.extractedText = extractedText
      this.extractedTitle = extractedText; // i don't know why this was added, but I will remove it
    }
    else {
      if (this.data.elementId.includes('-chart')) {
        this.title = this.data.elementId.replace('-chart', '');
      } else {
        this.title = this.data.elementId;
      }
      console.log('title', this.title)
    }
    if (this.data?.reportTitle)
      this.extractedTitle = this.data.reportTitle;
    if (!this.data?.reportName)
      this.reportName = this.extractedText;

    // end of bad code
  }

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() results: EventEmitter<any> = new EventEmitter();
  essentialData$: Observable<EssentialObject> = this.EssentialObject$.pipe(filter((x: EssentialObject) => x.tenant.key != null));

  @Output() isClosedWithoutExport: boolean = true
  languagePipe = AppInjector.get(LanguagePipe);

  dir = 'ltr';

  exportData(language?) {
    if (this.languagePipe.transform(language)) {
      this.dir = 'rtl';
    } else {
      this.dir = 'ltr';
    }
    this.isClosedWithoutExport = false;

    let element = document.getElementById('single-chart-export');
    let clonedElement = element.cloneNode(true) as HTMLElement;

    // Find and remove elements with the class 'border-zen' and 'border-opacity-10'
    let borderElements = clonedElement.querySelectorAll('.block.border.border-zen.border-opacity-10');
    borderElements.forEach((el) => {
      el.classList.remove('border', 'border-zen', 'border-opacity-10');
    });
    // Find and hide elements with the 'ByCriteria' class
    let byCriteriaElements = clonedElement.querySelectorAll('.ByCriteria');
    byCriteriaElements.forEach((el) => {
      (el as HTMLElement).style.display = 'none';
    });
    const zeroHeightElements = clonedElement.querySelectorAll('[style*="height: 0%"]');
    zeroHeightElements.forEach((el: HTMLElement) => {
      el.style.height = '100%';
    });
    var mywindow = window.open('', ' ', 'left=0,top=0,width=950,height=600,toolbar=0,scrollbars=0,status=0,addressbar=0');
    const agent = window.navigator.userAgent.toLowerCase();

    mywindow.document.write(document.head.innerHTML);
    mywindow.document.write(`<body dir='${this.dir}' style='background-color:white'>`);
    mywindow.document.write(clonedElement.innerHTML);  // Use the cloned element's innerHTML
    mywindow.document.write('</body>');
    mywindow.document.close();
    mywindow.document.title = this.title||this.extractedText;

    // Handle print logic for Chrome and other browsers
    if (agent.indexOf('chrome') > -1) {
      mywindow.onload = function () {
        mywindow.focus();
        setTimeout(() => {
          mywindow.print();
          mywindow.close();
        }, 2000);
      };
    } else {
      setTimeout(() => {
        mywindow.focus();
        mywindow.print();
        mywindow.close();
      }, 2000);
    }

    this.loaderService.hideLoader();
    this.results.emit('true');
  }



}
